__turbopack_context__.v({
  "container": "bento-box-module-scss-module__Tu9Zra__container",
  "containerMargin": "bento-box-module-scss-module__Tu9Zra__containerMargin",
});
